import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import appSebraeAtendimentoReadAction from './appSebraeAtendimentoRead.action.json' assert { type: 'json' }

const appSebraeAtendimentoReadDefinition = defineReadAutoAction(
  appSebraeAtendimentoReadAction,
  'atendimentoV2',
)

export default appSebraeAtendimentoReadDefinition
